import type { SegmentedControlValue } from '@vkontakte/vkui';
import type { EPromoTooltip } from 'reactApp/components/SharingWindow/Sharing.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export interface IProps {
    onClose?: () => void;
    onRendered?: () => void;
    itemStorage?: EStorageType;
    id: string;
    from: EFrom;
    gaSuffix?: string;
    isPhone?: boolean;
    fromEditor?: boolean;
    intraDomainShare?: boolean;
    autoSeo?: boolean;
    withPromoTooltip?: EPromoTooltip;
    folderName?: string;
    onboardingEnabled?: boolean;
}

export enum ExpiryPeriod {
    Unlimited = 'Unlimited',
    Hour = 'Hour',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Months3 = 'Months3',
    HalfYear = 'HalfYear',
    Year = 'Year',
    Expiry = 'Expiry',
}

export enum AutoDeletePeriod {
    None = 'None',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Months3 = 'Months3',
    HalfYear = 'HalfYear',
    Year = 'Year',
    Autodeleting = 'Autodeleting',
}

export interface IExpiresOptions {
    id: ExpiryPeriod;
    text: string;
    getValue: () => number;
    timeSize?: number;
}

export interface IAutoDeleteOptions {
    id: AutoDeletePeriod;
    text: string;
    getValue: () => number;
}

export enum EAccessRights {
    DELETE_USER = 'delete_user',
    UNMOUNT_USER = 'unmount_user',
    READ_WRITE = 'read_write',
    READ_ONLY = 'read_only',
    COMMENT = 'comment',
}

export interface IAccessRightsOptions {
    text: string;
    key: EAccessRights;
}

export enum AccessStatus {
    ReadOnly = 'ReadOnly',
    Edit = 'Edit',
    Upload = 'Upload',
    Download = 'Download',
    Comment = 'Comment',
}

export enum DownloadAccess {
    Unlimited = 'Unlimited',
    Limited = 'Limited',
}

export enum DomainAccess {
    DOMESTIC = 'domestic',
    EXTERNAL = 'external',
    EMAIL_LIST_ACCESS = 'email_list_access',
}

export enum EFrom {
    WEBLINK = 'weblink',
    SHARING = 'sharing',
    ALBUMS = 'albums',
}

export interface IInfo {
    access: string;
    name?: string;
    home?: string;
    owner: {
        email: string;
    };
}

export interface IGetTitleProps {
    isPublic: boolean;
    isMounted: boolean;
    showUsersScreen: boolean;
    name: string;
}

export interface IGetDescriptionProps {
    isFolder: boolean;
    personalSharingMode: SegmentedControlValue;
}

export interface DomainAccessOptions {
    id: DomainAccess;
    text: string;
    disabled?: boolean;
    dropdownText: string;
}
export type DropdownOptionValue = { id: string; text: string; dropdownText?: string };
export type DropdownOptions = Partial<Record<AccessStatus, DropdownOptionValue>>;
